<template>
    <!-- <div id="footer d-none">
        <footer >
            <div class="row">
                <div class="col-md-6 col-sm-6">
                    <div class="social-icon">
                        <ul>
                            <li><p class="mr-2">Follow us :</p></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-facebook social-icon-fa"></span></a></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-twitter social-icon-fa"></span></a></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-youtube-play social-icon-fa"></span></a></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-instagram social-icon-fa"></span></a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6">
                    <div class="c_div">
                        <span class="text-dark"><small>Powered By: </small></span>
                        
                        <template>
                            <img src="../assets/img/logo_svg_dt.svg" class="img-fluid c_logo ml-1" alt="Dure Technology">
                        </template>
                        
                        
                    </div>
                    <p class="float-right copyRightText mb-1"><small>Copyright <i class="fa fa-copyright" aria-hidden="true"></i> 2010-2020 Dure Technologies, All rights reserved</small></p>
                </div>
            </div>
        </footer>
    </div> -->
    <div id="footer">
        <footer >
            <div class="d-flex justify-content-between align-items-center mblViewfooter">
                
                    <div class="social-icon">
                        <ul>
                            <li><p class="mr-2 mb-0">Follow us :</p></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-facebook social-icon-fa"></span></a></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-twitter social-icon-fa"></span></a></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-youtube-play social-icon-fa"></span></a></li>
                            <li><a href="#" class="social_a_tag"><span class="fa fa-instagram social-icon-fa"></span></a></li>
                        </ul>
                    </div>
                
                    <p class="copyRightText mb-1"><small>Copyright <i class="fa fa-copyright" aria-hidden="true"></i> 2010-2020 Dure Technologies, All rights reserved</small></p>

                    <div class="c_div">
                        <span class="text-dark"><small>Powered By: </small></span>
                        
                        <template>
                            <img src="../assets/img/logo_svg_dt.svg" class="img-fluid c_logo ml-1" alt="Dure Technology">
                        </template>
                        
                        
                    </div>
                    
               
            </div>
        </footer>
    </div>
</template>
<script>
export default {
    data() {
        return {
        settings: settings
        };
    },
}
</script>
<style lang="scss" scoped>
.c_div .c_logo {
    width: 140px !important;
    padding-left: 0;
    // padding-right: 1%;
}
</style>